import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-standaard-projecten',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconStandaardProjecten {

  render() {
    return (
      <svg data-name="Layer 1" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M8.69 20h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1"/>
  <path d="M6.69 20c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1s1 .45 1 1v18c0 .55-.45 1-1 1"/>
  <path d="M6.69 11a.997.997 0 0 1-.4-1.91L13.23 6 6.29 2.91c-.51-.23-.73-.82-.51-1.32.23-.5.82-.73 1.32-.51l9 4a.998.998 0 0 1 0 1.82l-9 4c-.13.06-.27.09-.41.09Z"/>
</svg>

    );
  }
}
